import React from "react";

import { useGetSinglePlay } from "../../../../redux/slices";
import styles from "./play-list-item.module.scss";

interface PlayListItemProps {
  playId: string;
}

const PlayListItem = ({ playId }: PlayListItemProps) => {
  const { data: play, error } = useGetSinglePlay(playId);

  if (!play) return <div>loading...</div>;
  if (error) return <div>error...</div>;

  return (
    <div className={styles.playListItem}>
      <div>{play.name}</div>
    </div>
  );
};

export default PlayListItem;
